<style lang="scss" scoped>
.examBox {
  // border: 1px solid black;
  // width: 1200px;
  // height: 700px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 80px 67px 200px;
  margin: 50px auto 0;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  position: relative;
}
.content {
  width: 100%;
  // height: 417px;
  padding: 40px 0;
  background-color: #ebf6ff;
  border: 1px dashed #7bbcff;
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.rightOngoing,
.rightComing,
.rightEnded {
  display: none;
}
.contentRight,
.contentLeft {
  display: flex;
  justify-content: center;
}

.leftText {
  align-self: center;
  width: 460px;
  padding-left: 20px;
  // height: 220px;
  p {
    margin-top: 0;
    text-align: left;
    span.clickable {
      &:hover {
        cursor: pointer;
      }
      color: #3198ff;
    }
    span.inactive {
      color: #ff8a00;
      margin-right: 5px;
    }
    span.active {
      color: #25d476;
    }
    .itemLabel {
      color: black;
      font-weight: bold;
      margin-right: 10px;
    }
  }
  p:nth-of-type(1) {
    color: #3198ff;
    font-size: 24px;
  }
  p:nth-of-type(4) {
  }
}
.ongoing {
  .rightOngoing {
    align-self: center;
    width: 400px;
    height: 220px;
    display: grid;
    grid-template-rows: 1fr 1fr;
    border: 1px dashed #25d476;
    background-color: #eefff6;
    .status {
      color: #25d476;
      font-weight: bold;
      font-style: 26px;
      img {
        transform: translateY(5px) translateX(-5px);
      }
    }
    .time {
      p:nth-of-type(1) {
        font-weight: bold;
      }
      p:nth-of-type(2) {
        font-size: 30px;
        color: #ff5400;
      }
    }
  }
  .btnWrapper {
    .el-button {
      border: none;
      background-color: #3198ff;
      color: white;
      height: 40px;
      width: 152px;
      border-radius: 20px;
    }
  }
}
.ended {
  .rightEnded {
    align-self: center;
    width: 396px;
    height: 223px;
    display: flex;
    justify-content: center;
    border: 1px dashed #d2d2d2;
    background-color: #eee;
    .status {
      align-self: center;
      color: #d2d2d2;
      font-weight: bold;
      font-style: 26px;
      img {
        transform: translateY(5px) translateX(-5px);
      }
    }
  }
  .btnWrapper {
    .el-button {
      border: none;
      background-color: #3198ff;
      color: white;
      height: 40px;
      width: 152px;
      border-radius: 20px;
    }
  }
}
.coming {
  .rightComing {
    align-self: center;
    width: 396px;
    height: 223px;
    display: grid;
    grid-template-rows: 1fr 1fr;
    border: 1px dashed #ff8a00;
    background-color: #fff4e6;
    .status {
      color: #ff8a00;
      font-weight: bold;
      font-style: 26px;
      img {
        transform: translateY(5px) translateX(-5px);
      }
    }
    .time {
      p:nth-of-type(1) {
        font-weight: bold;
      }
      p:nth-of-type(2) {
        font-size: 30px;
        color: #ff5400;
      }
    }
  }
  // .btnWrapper {
  //   .el-button {
  //     border: none;
  //     background-color: #eee;
  //     color: #a5a5a5;
  //     height: 40px;
  //     width: 152px;
  //     border-radius: 20px;
  //   }
  // }
  .enterExamBtn {
    border: none;
    background-color: #eee;
    color: #a5a5a5;
    height: 40px;
    width: 152px;
    border-radius: 20px;
  }
  .enterPreExamBtn {
    border: none;
    background-color: #3198ff;
    color: white;
    height: 40px;
    width: 152px;
    border-radius: 20px;
  }
}

.preInfo {
  color: #ff5400;
}
.bottomWrapper {
  position: absolute;
  bottom: 66px;
  left: 50%;
  transform: translateX(-50%);
}
.seeGrade {
  margin-top: 20px;
}
</style>
<template>
  <div :class="{examBox: true,[timeToExam.status || 'ended']: true}">
    <div class="content">
      <div class="contentLeft">
        <div class="leftText">
          <p>{{myExam.title}}</p>
          <p>
            <span class="itemLabel">考试时间:</span>
            {{myExam | filterExamTime}}
          </p>
          <p>
            <span class="itemLabel">考试时长:</span>
            {{$moment(myExam.end_at).diff(myExam.start_at, 'minutes')}}分钟
          </p>

          <template v-if="timeToExam.status  !== 'ended' && myExam.is_hand === 0">
            <p>
              <span class="itemLabel">考试须知:</span>
              <span class="clickable" @click="handleCheckExamTips">考生须知</span>
            </p>
            <p>
              <span class="itemLabel">考前测试状态:</span>
              <span
                :class="{active:(myExam.testing_status === 1),inactive: true}"
              >{{myExam.preCheckStatus}}</span>
              <span
                class="clickable"
                v-if="(myExam.testing_status === 1&&timeToExam.status !== 'ended'&&!myExam.is_hand) || (myExam.is_online === 1 && myExam.testing_status === 2)"
                @click="handleGoCheckDevice"
              >再次测试</span>
            </p>
            <!-- 常规课,spo不需要人脸验证状态 -->
<!--            <p v-if="myExam.match_category !== 3 && myExam.match_category !== 2 && myExam.is_online !== 1">-->
<!--&lt;!&ndash;              <span class="itemLabel">人脸验证状态:</span>&ndash;&gt;-->
<!--              &lt;!&ndash; <span-->
<!--              :class="{active: myExam.faceCheckStatus !== '未验证' && myExam.faceCheckStatus !== '验证失败',inactive: true}"-->
<!--              >{{myExam.faceCheckStatus}}</span>&ndash;&gt;-->
<!--              <span-->
<!--                v-if="!comingInOneHour && faceCheckGetter"-->
<!--                :class="{active: faceCheckGetter && faceCheckGetter.prepassed,inactive: true}"-->
<!--              >{{faceStatus}}</span>-->
<!--              <span-->
<!--                v-else-if="faceCheckGetter"-->
<!--                :class="{active: checkedInOneHour,inactive: true}"-->
<!--              >{{faceStatus}}</span>-->
<!--              <span class="inactive" v-if="myExam.is_online === 1">（线下考生免验证）</span>-->
<!--              <span class="clickable"-->
<!--                v-if="timeToExam.status === 'coming' && timeToExam.value <= 1*60*60*1000 && !checkedInOneHour && !uploadedInOneHour &&!myExam.is_test_check && myExam.match_category !== 3 && myExam.match_category !== 2 && myExam.is_online !== 1"-->
<!--                @click="handleGoCheckFace"-->
<!--              >马上验证</span>-->
<!--            </p>-->
          </template>
          <!-- <p>
            <span class="itemLabel">考试人脸验证状态:</span>
            <span
              :class="{active: checkedInOneHour,inactive: true}"
            >{{checkedInOneHour ? '已通过':'未通过'}}</span>
          </p>-->
          <template v-if="timeToExam.status  === 'ended' || myExam.is_hand">
            <p>
              <span class="itemLabel">考试总分:</span>
              {{myExam.total_score}}
            </p>
            <p>
              <span class="itemLabel">参加考试状态:</span>
              {{myExam.is_hand ? '已参加':'未参加'}}
            </p>
            <!-- 常规课spo不需要显示我的成绩一栏 -->
            <p v-if="myExam.match_category !== 3 && myExam.match_category !== 2">
              <span class="itemLabel">我的成绩:</span>
              {{myScore}}
            </p>
          </template>
        </div>
      </div>
      <div class="contentRight">
        <div class="rightEnded">
          <p class="status">
            <img src="../../assets/images/ended.png" alt />
            {{timeToExam.title}}
          </p>
        </div>
        <div class="rightOngoing">
          <p class="status">
            <img src="../../assets/images/ongoing.png" alt />
            {{timeToExam.title}}
          </p>
          <div class="time">
            <p>{{timeToExam.subtitle}}</p>
            <p>{{timeToExam.value | secToFormat}}</p>
          </div>
        </div>
        <div class="rightComing">
          <p class="status">
            <img src="../../assets/images/notice.png" alt />
            {{timeToExam.title}}
          </p>
          <div class="time">
            <p>{{timeToExam.subtitle}}</p>
            <p>{{timeToExam.value | secToFormat}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomWrapper">
      <template v-if="myExam.match_category === 3 || myExam.match_category === 2 || myExam.is_online === 1">
       <p
        class="preInfo"
        v-show="timeToExam.status  !== 'ended'&&!myExam.is_hand"
      >仅当完成考前测试才能进入考试</p>
      </template>
      <template v-else>
        <p
          class="preInfo"
          v-show="timeToExam.status  !== 'ended'&&!myExam.is_hand"
        >仅当完成考试前测试才能进入考试</p>
      </template>
      <p class="btnWrapper">
        <template
          v-if="timeToExam.status  === 'coming' || timeToExam.status ==='ongoing' && !myExam.is_hand"
        >
          <el-button
            class="enterExamBtn"
            v-if="myExam.testing_status === 1 || (myExam.is_online === 1 && myExam.testing_status === 2)"
            :disabled="!myExam || JSON.stringify(myExam) ==='{}' || timeToExam.status !== 'ongoing'"
            @click="handleEnterExam"
          >进入考试</el-button>
          <el-button
            class="enterPreExamBtn"
            v-else
            :disabled="!myExam || JSON.stringify(myExam) ==='{}'"
            @click="handleEnterPreExam"
          >进入考前测试</el-button>
        </template>
      </p>
    </div>
    <!-- <div class="seeGrade" v-if="timeToExam.status  === 'ended' && myExam.is_hand">
      <el-button type="primary" size="small" @click="seeGrade">查看成绩</el-button>
    </div> -->
    <!-- 浏览器检测 -->
    <base-chrome-check :dialogVisible.sync="browserNotOk" :myExam="myExam"></base-chrome-check>
    <base-pdf :showReadIt="showReadIt" @finish-read-tips="handleFinishRead" :dialogVisible.sync="pdfVisible" :pdfSrc="myExam.exam_file_url"></base-pdf>
    <base-ad :dialogVisible.sync="showAd"></base-ad>
  </div>
</template>
<script>
import {
  // getExamination,
  // postAnswer,
  // putAnswer,
  // postFaceCheck,
  // postExaminationVideo,
  // getServerTime,
  // getMyExam,
  postSwitchScreen,
} from '@/services/getData';

import {
 mapMutations, mapState, mapGetters, mapActions,
} from 'vuex';
import {
 AUTHORITY, EXAMINEE, MYEXAM, SERVERTIME,
} from '@/store/types';
import BasePdf from '@/components/BasePdf.vue';
import BaseAd from '@/components/BaseAd.vue';
import BaseChromeCheck from '@/components/BaseChromeCheck.vue';
import codepku from '../../utils/codepku';
const browser = codepku.browserType();
export default {
  data() {
    return {
      browser,
      browserNotOk: false,
      options: [],

      pdfVisible: false,
      // myExam: {},
      // myExam.id 就是examination_examinee_id
      faceCheck: null,
      showAd: false,
    };
  },
  methods: {
    ...mapMutations({
      setAuthority: AUTHORITY,
      setExaminee: EXAMINEE,
      setMyExam: MYEXAM,
      setServerTime: SERVERTIME,
    }),
    //查看成绩
    seeGrade() {
      // console.log(this.myExam,'aaaa');
      this.$router.push(`/grade?id=${this.myExam.id}`);//查看成绩
    },
    handleEnterExam() {
      if (this.timeToExam.status === 'ongoing') {
        if (this.myExam.is_online === 1) {//如果是线下考生考试
            this.$router.push('/exam'); // 可以直接去考试了
        }
        else {
          if (
            this.checkedInOneHour
            || this.uploadedInOneHour
            || this.myExam.is_test_check
            || this.myExam.match_category === 3
            || this.myExam.match_category === 2
          ) {
            this.$router.push('/exam'); // 可以直接去考试了
          } else if (this.faceCheckGetter.count >= 5) {
            return this.$router.push('/user/myface?upload=1'); // 使用upload模式
          } else {
            this.$router.push('/user/myface'); // 自动模式
          }
        }
      }
      return undefined;
    },
    handleEnterPreExam() {
      if (this.comingInOneHour) {
        // 如果已经到了考试时间
        if (this.myExam.is_online === 1) {//如果是线下考生考试
          this.$router.push('/user/devicetest/3');//直接跳到第三步
        }else {
          if (
            this.uploadedInOneHour
            || this.checkedInOneHour
            || this.myExam.is_test_check
            || this.myExam.match_category === 3
            || this.myExam.match_category === 2
          ) {
            this.$router.push('/user/devicetest/1'); // 考试阶段（包括前1小时）已通过人脸
          } else if (this.faceCheckGetter.count >= 5) {
            // 如果已经超过了5次
            this.$router.push('/user/myface?upload=1');
          } else {
            this.$router.push('/user/myface');
          }
        }
      } else {
        if (this.myExam.is_online === 1) {
          this.$router.push('/user/devicetest/3');//直接跳到第三步
        }
        else {
          if (
            this.myExam.examinee_tencent_face_testing
            || this.faceCheckGetter.preuploaded
            || this.uploadedInOneHour
            || this.myExam.is_test_check
            || this.myExam.match_category === 3
            || this.myExam.match_category === 2
          ) {
            this.$router.push('/user/devicetest/1');
          } else if (this.faceCheckGetter.precount >= 5) {
            this.$router.push('/user/myface?upload=1'); // 使用upload模式
          } else {
            this.$router.push('/user/myface'); // 自动模式
          }
        }
      }
    },
    // setServerTime() {
    //   getServerTime()
    //     .then((resp) => {
    //       this.serverTime = new Date(resp);
    //       this.serverTimer = setInterval(() => {
    //         // 根据服务器时间设置定时器
    //         this.serverTime = new Date(this.serverTime.valueOf() + 1000);
    //       }, 1000);
    //     })
    //     .catch((err) => {});
    // },
    processExamInfo(examInfo) {
      const obj = Object.assign({}, examInfo);
      if (!examInfo.examinee_tencent_faces.length) {
        obj.faceCheckStatus = '未验证';
      } else if (examInfo.examinee_tencent_face_testing) {
        obj.faceCheckStatus = '验证成功';
      } else {
        obj.faceCheckStatus = '验证失败';
      }
      if (examInfo.testing_status === 1) {
        obj.preCheckStatus = '已完成';
      }
      if (examInfo.testing_status === 2 && examInfo.is_online === 1) {
        obj.preCheckStatus = '已完成';
      }
      if (examInfo.testing_status === 2 && examInfo.is_online !== 1) {
        obj.preCheckStatus = '检测失败';
      }
      if (examInfo.testing_status === 0) {
        obj.preCheckStatus = '未完成';
      }
      return obj;
    },
    handleCheckExamTips(e) {
      e.preventDefault();
      this.pdfVisible = true;
    },
    handleGoCheckFace() {
      this.$router.push('/user/myface');
    },
    handleGoCheckDevice() {
      if (this.myExam.is_online !== 1) {
        this.$router.push('/user/devicetest/1');
      }else {
        this.$router.push('/user/devicetest/3');
      }

    },
    handleFinishRead() {
      console.log('postSwitchScreen');
      postSwitchScreen(this.examinee.examination_examinee_id, {
        category: 4,
        remark: '已阅读',
      }).then((result) => {
        this.pdfVisible = false;
        this.$message.success('已阅读考试须知');
        this.disMyExam(this.authority.admissionTicket);
      }).catch((err) => {
        console.log(err);
      });
    },
    ...mapActions({
      disMyExam: MYEXAM,
    }),
  },
  components: {
    BasePdf,
    BaseChromeCheck,
    BaseAd,
  },
  created() {
    if (!this.authority) {
      const ls = localStorage.getItem('authority');
      this.setAuthority(JSON.parse(ls));
    }
    const faceCheck =      localStorage.getItem(`faceCheck-${this.authority.admissionTicket}`)
      || '{}';
    this.faceCheck = JSON.parse(faceCheck);
    var version = parseInt(this.browser.version, 10);
    if (version < 72) {
      this.browserNotOk = true;
    }
  },
  mounted() {},
  beforeDestroy() {
    // window.clearInterval(this.serverTimer);
  },
  props: {},
  watch: {
    myExam: {
      handler(val) {
        if (val && Array.isArray(val.examinee_operations) && (new Date() < new Date(val.end_at)) && val.is_hand === 0) {
          if (this.myExam.examinee_operations.every((item, index) => item.category !== 4)) {
            this.pdfVisible = true;
          }
        }
        if (this.myExam.is_hand) {
          this.showAd = true;
        }
      },
      deep: true,
    },
  },
  computed: {
    timeToExam() {
      let time = {};
      if (this.serverTime - new Date(this.myExam.end_at) > 0) {
        // 考试已结束
        time = {
          title: '考试已结束',
          subtitle: '考试已结束',
          value: this.serverTime - new Date(this.myExam.end_at),
          status: 'ended',
        };
        return time;
      }
      if (this.serverTime - new Date(this.myExam.start_at) > 0) {
        // 考试中
        time = {
          title: '考试进行中...',
          subtitle: '距离考试结束',
          value: new Date(this.myExam.end_at) - this.serverTime,
          status: 'ongoing',
        };
        return time;
      } // 考试未开始
      time = {
        title: '考试未开始',
        subtitle: '距离考试开始',
        value: new Date(this.myExam.start_at) - this.serverTime,
        status: 'coming',
      };
      return time;
    },
    ...mapState({
      authority: 'authority',
      examinee: 'examinee',
      currentUser: 'currentUser',
      myExamV: 'myExam',
      serverTime: 'serverTime',
    }),
    ...mapGetters({
      faceCheckGetter: 'faceCheckGetter',
    }),
    myExam() {
      if (this.myExamV && JSON.stringify(this.myExamV) !== '{}') {
        return this.processExamInfo(this.myExamV);
      }
      return {};
    },
    myScore() {
      if (this.myExamV && this.myExamV.achievements) {
        switch (this.myExamV.achievement_status) {
          case 0:
            return '0 (考试作弊，已被取消考试成绩)';
          case 1:
            return this.myExam.is_hand ? '考试成绩未公布' : '无成绩';
          case 2:
            return `${this.myExamV.achievements.objective_score
              + this.myExamV.achievements.subjective_score}分`;
          default:
            return '无成绩';
        }
      }
      return '考试成绩暂未发布';
    },
    checkedInOneHour() {
      return (
        this.faceCheck.successStamp
        && new Date(this.myExamV.start_at)
          - new Date(this.faceCheck.successStamp)
          < 60 * 60 * 1000
      );
    },
    uploadedInOneHour() {
      return (
        this.faceCheck.uploadStamp
        && new Date(this.myExamV.start_at) - new Date(this.faceCheck.uploadStamp)
          < 60 * 60 * 1000
      );
    },
    comingInOneHour() {
      // 考前1小时加考试结束前的时间
      const startAt = new Date(this.myExamV.start_at);
      const endAt = new Date(this.myExamV.end_at);
      const now = new Date(this.serverTime);
      return startAt - now < 60 * 60 * 1000 && endAt > now;
    },
    faceStatus() {
      //分为开考1小时以前和开考1小时以后，验证通过（人脸，或者）
      if (this.comingInOneHour) {
        if (this.faceCheckGetter.count >= 5 && !this.checkedInOneHour) {
          return '验证失败';
        }
        if (this.uploadedInOneHour || this.checkedInOneHour) {
          return '验证通过';
        }
        if (this.faceCheckGetter.count < 5 && this.faceCheckGetter.count > 0) {
          return `剩余自助验证机会${5 - this.faceCheckGetter.count}次`;
        }
        if (this.faceCheckGetter.count === 0) {
          return '未验证';
        }
      } else {
        if (this.myExam.examinee_tencent_face_testing) {
          return '验证通过';
        }
        if (this.faceCheckGetter.precount >= 5) {
          return '验证失败';
        }
        if (
          this.faceCheckGetter.precount < 5
          && this.faceCheckGetter.precount > 0
        ) {
          return `剩余自助验证机会${5 - this.faceCheckGetter.precount}次`;
        }
        if (this.faceCheckGetter.precount === 0) {
          return '未验证';
        }
      }
      return '';
    },
    showReadIt() {
      if (!this.myExam || !Array.isArray(this.myExam.examinee_operations)) return false;
      return !this.myExam.examinee_operations.some((item, index) => item.category === 4);
    },
  },
  filters: {
    secToFormat(minisec) {
      if (!minisec) return '--:--:--';
      const duration = $moment.duration(minisec);
      if (minisec > 24 * 60 * 60 * 1000) {
        return `${duration.get('days')}天`;
      }
      const hour = duration.get('hours');
      const min = duration.get('minutes');
      const sec = duration.get('seconds');
      return `${hour > 9 ? hour : `0${hour}`}:${min > 9 ? min : `0${min}`}:${
        sec > 9 ? sec : `0${sec}`
      }`;
    },
    filterExamTime(myExam) {
      if (myExam.start_at) {
        const startAtArr = myExam.start_at.split(' ');
        const endAtArr = myExam.end_at.split(' ');
        if (startAtArr[0] && endAtArr[0] && startAtArr[0] === endAtArr[0]) {
          return `${startAtArr[0]} ${startAtArr[1]}--${endAtArr[1]}`;
        }
        return `${myExam.start_at}--${myExam.end_at}`;
      }
      return '';
    },
  },
};
</script>
